var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenderFemaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 2H8.875C8.66875 2 8.5 2.16875 8.5 2.375V2.625C8.5 2.83125 8.66875 3 8.875 3H10.2937L7.30937 5.98438C6.5375 5.36875 5.5625 5 4.5 5C2.01562 5 0 7.01562 0 9.5C0 11.9844 2.01562 14 4.5 14C6.98438 14 9 11.9844 9 9.5C9 8.4375 8.63125 7.4625 8.01562 6.69063L11 3.70625V5.125C11 5.33125 11.1687 5.5 11.375 5.5H11.625C11.8313 5.5 12 5.33125 12 5.125V2.375C12 2.16875 11.8313 2 11.625 2ZM4.5 13C2.56562 13 1 11.4375 1 9.5C1 7.56563 2.5625 6 4.5 6C6.43437 6 8 7.5625 8 9.5C8 11.4344 6.4375 13 4.5 13Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderFemaleIcon);
export default __webpack_public_path__ + "static/media/gender-female-icon.696f564f14009579f42fb44d85a3baa5.svg";
export { ForwardRef as ReactComponent };